var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { City } from 'packages/location/City';
import ENV from 'config/env';
var LocationRepository = /** @class */ (function (_super) {
    __extends(LocationRepository, _super);
    function LocationRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.baseUrl = ENV.JOBILLA_API_ROOT + "v3/";
        _this.entity = City;
        _this.url = '';
        return _this;
    }
    LocationRepository.prototype.getInUseForJobs = function (company) {
        return this.getAll('companies/:company/jobs/cities', { company: company });
    };
    return LocationRepository;
}(AbstractRepository));
export { LocationRepository };
